import React from "react";
import imageUpload from "assets/svgs/imageUpload.svg";
import removeImg from "assets/svgs/close.svg";
import server from "api/server";
import { handleImage } from "helpers/functions";

const ImageUpload = ({
  selectedImage,
  setSelectedImage,
  accept = "image/*",
}) => {
  const imageChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const formData = new FormData();
      formData.append("file", e.target.files[0]);
      const { data } = await server().post("/upload", formData);

      setSelectedImage({
        preview: e.target.file,
        path: process.env.REACT_APP_URL + data.data.file.path,
      });
    }
  };

  const removeSelectedImage = () => {
    setSelectedImage("");
  };

  return (
    <div className="image-uploader image-contain">
      <div className="img-pat">
        <img src={imageUpload} width={46} height={46} alt="" />
      </div>
      <label>
        {(selectedImage?.preview || selectedImage?.path) && (
          <div>
            {selectedImage?.path?.includes("pdf") ? (
              <embed
                src={handleImage(selectedImage?.path)}
                width={160}
                height={160}
                type="application/pdf"
              />
            ) : (
              <img
                src={
                  selectedImage && selectedImage.preview
                    ? URL.createObjectURL(selectedImage.preview)
                    : selectedImage?.path
                    ? handleImage(selectedImage?.path)
                    : imageUpload
                }
                width={160}
                height={160}
                alt=""
              />
            )}
            <button className="removeImg" onClick={removeSelectedImage}>
              <img src={removeImg} alt="" />
            </button>
          </div>
        )}
        <input accept={accept} type="file" onChange={imageChange} />
      </label>
    </div>
  );
};

export default ImageUpload;
